import React from "react";
import { FaLeaf, FaGlobeAfrica, FaHandsHelping, FaHandshake, FaSeedling } from "react-icons/fa";

const certs = [
  { icon: FaLeaf, label: "Organic Practices" },
  { icon: FaGlobeAfrica, label: "Rainforest Care" },
  { icon: FaHandsHelping, label: "Women-Owned" },
  { icon: FaHandshake, label: "Direct Trade" },
  { icon: FaSeedling, label: "100% Arabica" },
];

const Certifications = () => {
  return (
    <section className="bg-cream-warm px-5 py-12 md:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <p className="mb-8 text-center text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
          Trusted Standards
        </p>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {certs.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center gap-3 rounded-2xl border border-cream-muted bg-white px-4 py-6 text-center"
            >
              <Icon className="text-2xl text-gold" />
              <p className="text-sm font-semibold text-espresso">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
